


















































































import Vue from "vue";
import Component from "vue-class-component";
import { api, copyToClipboard, getParams, isWeixin, isMobile } from "@/api";
import ArticleCard from "@/components/ArticalCard.vue";
import wx from "wx-jssdk-ts";
import { Toast } from "vant";
import QrcodeVue from "qrcode.vue";

@Component({
  components: { ArticleCard, QrcodeVue },
})
export default class Article extends Vue {
  public tabBar: string = "article";
  protected loading: boolean = false;
  protected lists: any[] = [];
  protected finished: boolean = false;
  protected error: boolean = false;
  public active: number = 0;
  protected showShare: boolean = false;
  protected text: string = "";
  protected config: any = null;
  protected wxShareContentConfig: any = null;
  protected showWxShare = false;
  protected isWeixinShare: any = false;

  protected total: number = 0; // 总数
  protected page: number = 1; // 页数

  public options: any[] = [
    // { name: "分享", icon: "link" },
    // { name: "微信", icon: "wechat" },
    // { name: "朋友圈", icon: "" },
    // { name: "QQ", icon: "qq" },
    // { name: "QQ空间", icon: "" },
    {
      name: "微信",
      icon: require("@/assets/image/icon-wechat.png"),
      value: "wechat",
    },
    {
      name: "朋友圈",
      icon: require("@/assets/image/icon-moment.png"),
      value: "wechat",
    },
    {
      name: "QQ好友",
      icon: require("@/assets/image/icon-qq.png"),
      value: "qq",
    },
    {
      name: "QQ空间",
      icon: require("@/assets/image/icon-qzone.png"),
      value: "qzone",
    },
  ];
  public created() {}

  public async mounted() {
    this.active = Number(getParams("appId"));
    console.log(getParams("appId"), this.active);
    this.config = await api.getWxShareConfig();
    this.wxReady();
    this.onLoad();
  }

  public async onLoad(done: any = null, type: string = "") {
    const resp = await api.getArticleList({
      page: this.page,
      appId: this.active,
    });
    this.loading = false;
    if (!resp.data.length) {
      this.finished = true;
    } else {
      this.lists.push(...resp.data);
      console.log(44);
      if (resp.last_page == this.page) {
        this.finished = true;
      }
    }
    this.total = resp.last_page;
  }
  public onRefresh(done: any) {
    console.log("onRefresh");
    this.page = 1;
    this.lists = [];
    this.onLoad(done, "refresh");
  }
  public loadMore(done: any) {
    console.log("onRefresh");
    this.page++;
    this.onLoad(done, "load");
  }

  public share(option: any, index: number) {
    console.log(option, index, this.wxShareContentConfig);
    wx.ready(() => {
      wx.updateAppMessageShareData(this.wxShareContentConfig);
      wx.updateTimelineShareData({
        title: this.wxShareContentConfig.title,
        link: this.wxShareContentConfig.link,
        imgUrl: this.wxShareContentConfig.imgUrl,
        success: () => {},
        cancel(): void {},
      });
    });
    let linkUrl = "";
    this.isWeixinShare = isWeixin() && isMobile();
    switch (option.value) {
      case "qq":
        // copyToClipboard(this.wxShareContentConfig.link);
        linkUrl =
          "http://connect.qq.com/widget/shareqq/index.html?url=" +
          this.wxShareContentConfig.link +
          (!!~this.wxShareContentConfig.link.indexOf("?") ? "&" : "?") +
          "sharesource=qzone&title=" +
          this.wxShareContentConfig.title +
          "&pics=" +
          this.wxShareContentConfig.imgUrl +
          "&summary=" +
          this.wxShareContentConfig.desc +
          "&desc=" +
          this.wxShareContentConfig.desc;
        break;
      case "wechat":
        this.showWxShare = true;
        break;
      case "qzone":
        linkUrl =
          "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
          this.wxShareContentConfig.link +
          (!!~this.wxShareContentConfig.link.indexOf("?") ? "&" : "?") +
          "sharesource=qzone&title=" +
          this.wxShareContentConfig.title +
          "&pics=" +
          this.wxShareContentConfig.imgUrl +
          "&summary=" +
          this.wxShareContentConfig.desc;
        break;
    }
    if ((isMobile() || isWeixin()) && linkUrl) {
      location.href = linkUrl;
    }
    if (!isMobile() && linkUrl) {
      window.open(linkUrl);
    }

    this.showShare = false;
  }

  public onChangeContent(config: any) {
    this.wxShareContentConfig = config;
  }

  public onChangeShow(value: boolean) {
    this.showShare = value;
  }

  public wxReady() {
    wx.checkJsApi({
      jsApiList: this.config.jsApiList, // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success: async (res) => {
        // 以键值对的形式返回，可用的api值true，不可用为false
        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        let canShare = true;
        for (let resKey in res.checkResult) {
          if (!res.checkResult[resKey]) {
            canShare = res.checkResult[resKey];
          }
        }
        if (canShare) {
          let config = this.config;
          wx.config({
            debug: config.debug,
            appId: config.appId,
            timestamp: config.timestamp,
            nonceStr: config.nonceStr,
            signature: config.signature,
            jsApiList: config.jsApiList,
          });
        }
      },
    });
  }
}
